module.exports = __webpack_public_path__ + "static/media/bac-logo.e5c5d02b.svg";